import { pushToDataLayer } from './pushToDataLayer';

let isInstalled = false;

const logUiClick = (selector: string) => {
  pushToDataLayer({
    event: 'ui-click',
    selector,
  });
};

export const installUiClickListener = () => {
  if (isInstalled) {
    return;
  }
  isInstalled = true;

  document.addEventListener(
    'click',
    event => {
      const { target } = event;
      if (!(target instanceof Element)) {
        return;
      }
      const selector = target.closest('[data-cy]')?.getAttribute('data-cy');
      if (selector) {
        logUiClick(selector);
      }
    },
    { capture: true }
  );
};
